import { lazyInitMatchCardsListsAppenderRuntime } from "./lazyInitMatchCardsListsAppendertRuntime";
import type { MatchCardsListsAppenderComponent } from "@motain/xpa-proto-files-web/lib/types/match_cards_lists_appender";
import { isValidHTTPStatusCode } from "@/utils/isValidHTTPStatusCode";
import { remoteLogger } from "@/utils/remoteLogger";
import { isNullable } from "@/types/isNullable";
import { FETCH_METHOD } from "@/constants/fetch-method";
import { apiFetchWithDecode } from "@/utils/apiFetchWithDecoder";

/*
   Function that calls the LoadMoreMatches endpoint
   - In case of success:  returns the missing MatchCardLists into a MatchCardsListsAppenderComponent.
   - In case of error:  returns undefined, and logs the error.
 */
export const getAllMatches = async (
  url: string,
): Promise<MatchCardsListsAppenderComponent | undefined> => {
  try {
    const decoder = await lazyInitMatchCardsListsAppenderRuntime();
    const response = await apiFetchWithDecode<MatchCardsListsAppenderComponent>(
      url,
      { method: FETCH_METHOD.GET, decoder },
    );

    if (
      isNullable(response.decoded) ||
      !isValidHTTPStatusCode(response.status)
    ) {
      remoteLogger.error(
        "Error trying to fetch additional match-cards-lists-appender",
        response,
      );

      return undefined;
    }

    return response.decoded;
  } catch (err) {
    remoteLogger.error(
      "Error trying to fetch additional match-cards-lists-appender",
      err,
    );

    return undefined;
  }
};
